import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@barthauer/abc/queries/opath/core';
import {
  AbcAccordionComponent,
  AbcDropDownBoxButtonComponent,
  AbcDropDownBoxComponent,
  AbcListComponent,
  AbcNumberBoxComponent,
  AbcTabPanelComponent,
  AbcTextBoxComponent,
  _AbcButtonComponent,
  _AbcCheckBoxComponent,
  _AbcGridComponent,
  _AbcSplitterComponent,
  _AbcTreeComponent,
} from '@barthauer/abc/ui-components';
import {
  DxDataGridModule,
  DxDropDownButtonModule,
  DxLoadIndicatorModule,
  DxScrollViewModule,
  DxTreeViewModule,
} from 'devextreme-angular';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { AbcLoadIndicatorComponent } from '../../../../../ui-components/src/lib/core/src/abc-load-indicator/abc-load-indicator.component';
import { AbcQueriesEditorComponent } from './abc-queries-editor.component';
import { ColumnPropertiesComponent } from './core/properties/column-properties/column-properties.component';
import { GeneralPropertiesComponent } from './core/properties/general-properties/general-properties.component';
import { QueryPropertiesComponent } from './core/properties/query-properties/query-properties.component';
import { QueriesTreeComponent } from './core/queries-tree/queries-tree.component';
import { ResultsJsonComponent } from './core/results/results-json/results-json.component';
import { ResultsQueryJsonComponent } from './core/results/results-query-json/results-query-json.component';
import { ResultsQueryXmlComponent } from './core/results/results-query-xml/results-query-xml.component';
import { NestedGridComponent } from './core/results/results-table/nested-grid/nested-grid.component';
import { ResultsTableComponent } from './core/results/results-table/results-table.component';
import { ResultsXmlComponent } from './core/results/results-xml/results-xml.component';
import { ResultsComponent } from './core/results/results.component';
import { SelectColumnsComponent } from './core/select/select-columns/select-columns.component';
import { SelectObjectTypeComponent } from './core/select/select-object-type/select-object-type.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    _AbcGridComponent,
    _AbcSplitterComponent,
    AbcAccordionComponent,
    _AbcButtonComponent,
    AbcTextBoxComponent,
    AbcDropDownBoxComponent,
    DxScrollViewModule,
    DragDropModule,
    AbcLoadIndicatorComponent,
    DxLoadIndicatorModule,
    AbcNumberBoxComponent,
    _AbcCheckBoxComponent,
    AbcAccordionComponent,
    _AbcTreeComponent,
    DxTreeViewModule,
    DxDataGridModule,
    AbcTabPanelComponent,
    DxDropDownButtonModule,
    AbcListComponent,
    FlexLayoutModule,
    AbcDropDownBoxButtonComponent,
    // ExpressionsEditorModule,
  ],
  declarations: [
    AbcQueriesEditorComponent,
    GeneralPropertiesComponent,
    QueryPropertiesComponent,
    ColumnPropertiesComponent,
    QueriesTreeComponent,
    SelectColumnsComponent,
    SelectObjectTypeComponent,
    ResultsComponent,
    ResultsTableComponent,
    ResultsXmlComponent,
    ResultsQueryXmlComponent,
    ResultsQueryJsonComponent,
    NestedGridComponent,
    ResultsJsonComponent,
  ],
  exports: [
    AbcQueriesEditorComponent,
    GeneralPropertiesComponent,
    QueryPropertiesComponent,
    ColumnPropertiesComponent,
    QueriesTreeComponent,
    SelectColumnsComponent,
    SelectObjectTypeComponent,
    ResultsComponent,
    ResultsTableComponent,
    ResultsXmlComponent,
    ResultsQueryXmlComponent,
    ResultsQueryJsonComponent,
    NestedGridComponent,
  ],
})
export class QueriesEditorModule {}
